<template>
    <editing-sub-frame :sub_type="sub_type" :sub_code="sub_code" :sub_guide="sub_data_contents_information">
        <template #head>
            <!--제목, 컴포넌트 기본 공통 -->

            <!--     label이 있는 경우에만 폼 활성화        -->
            <template v-if="label">
                <div class="mt-3 mb-1 fw-600 f-90"> Sub label *</div>
                <b-form-input v-model="sub_label" placeholder="필수 입력"/>
            </template>

            <div class="mt-3 mb-1 fw-600 f-90"> Sub type</div>
            <div class="d-flex justify-content-between">
                <b-dropdown :text="sub_type" variant="dark-border" class="mr-2">
                    <b-dropdown-item-button v-for="(sub_type, sub_type_idx) in sub_types"
                                            :key="`subs-radio-subtype-opt-${sub_type}-${sub_type_idx}`"
                                            @click="selectType(sub_type)"
                    >
                        {{ sub_type }}
                    </b-dropdown-item-button>
                </b-dropdown>
                <b-form-input v-model="sub_name" placeholder="Title (필요시 작성)"/>
            </div>

            <div class="mt-3 mb-1 fw-600 f-90"> Description</div>
            <b-textarea
                v-model="sub_description"
                placeholder="A1. ㅇㅇㅇ을 관리하고 있습니까?"
            />

            <div class="mt-3 mb-1 fw-600 f-90"> Info</div>
            <b-textarea
                v-model="sub_info"
                placeholder="용어설명, 참고사항, 평가기준 등 답변 참고정보"
                rows="10"
            />
        </template>

        <template #structure>
            <!-- Radio Structure -->
            <b-card no-body class="border-top-0 border-bottom-0 mb-2">
                <b-table-simple class="mb-0" bordered hover>
                    <b-thead>
                        <b-tr>
                            <b-th class="bgray-100"/>
                            <b-th class="bgray-100"> text</b-th>
                            <b-th class="bgray-100"> value</b-th>
                            <b-th class="bgray-100 text-center" style="max-width: 70px;"> 세부요소</b-th>
                            <b-th v-if="sub_data_header.scoring=='auto'" class="bgray-100 text-center"> 배점(총 10점)</b-th>
                            <b-th class="bgray-100 text-center"> 삭제</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody v-for="(item, index) in sub_data_contents.structure"
                             :key="`subs-structure-${index}`"
                    >
                        <b-tr>
                            <b-td class="bgray-100 align-middle text-center">
                                <b-form-radio class="mr-0" :disabled="true"/>
                            </b-td>
                            <b-td>
                                <b-form-input v-model="item.text" size="sm"/>
                            </b-td>
                            <b-td>
                                <b-form-input v-model="item.value" size="sm"/>
                            </b-td>
                            <b-td class="align-middle text-center">
                                <b-button variant="teal-border" size="sm"
                                          @click="addElement(index)"
                                >
                                    <fa icon="plus"></fa>
                                </b-button>
                            </b-td>
                            <b-td v-if="sub_data_header.scoring=='auto'" class="align-middle text-center">
                                <b-form-input type='number' v-model="item.score"/>
                            </b-td>
                            <b-td class="align-middle text-center">
                                <b-button
                                    variant="dark-border"
                                    size="sm"
                                    @click="sub_data_contents.structure.splice(index,1)"
                                >
                                    <fa icon="trash-alt"></fa>
                                </b-button>
                            </b-td>
                        </b-tr>
                        <b-tr v-for="(element_item, element_idx) in item.element_contents"
                              :key="element_item.id"
                        >
                            <b-td></b-td>
                            <b-td colspan="5">
                                <editing-df-element
                                    :item_idx="index"
                                    :element_idx="element_idx"
                                    :element_item="element_item"
                                    @change="updateElementItem"
                                >
                                </editing-df-element>
                            </b-td>
                            <b-td class="text-center">
                                <b-button variant="dark-border" size="sm"
                                          @click="deleteElement(index, element_idx)"
                                >
                                    <fa icon="trash-alt"></fa>
                                </b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

            <div class="d-flex justify-content-between">
                <b-form-checkbox
                    v-model="sub_data_header.horizontal"
                    class="blue"
                >
                    선택지를 가로방향으로 표시
                </b-form-checkbox>
                <b-button
                    variant="teal"
                    size="sm"
                    @click="addRadio"
                >
                    라디오 선택지 추가
                </b-button>
            </div>
        </template>

        <template #option>
            <!-- Tags, Child 등 기본 공통 -->
            <b-list-group>
                <b-list-group-item>
                    <editing-sub-submit-required v-model="submit_required" :sub_code="sub_code" />
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="해당없음"
                        :label-for="`editing-subs-radio-${sub_code}-enable_na`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-radio-${sub_code}-enable_na`"
                                         v-model="enable_na"
                        >
                            선택지에 '해당없음' 추가
                        </b-form-checkbox>
                    </b-form-group>

                    <template v-if="enable_na">
                        <b-form-group
                            label-cols="12"
                            label-cols-md="4"
                            label-cols-xl="2"
                            content-cols="12"
                            content-cols-md="8"
                            content-cols-xl="9"
                            label="해당없음 선택지 문구"
                            :label-for="`editing-subs-radio-${sub_code}-enable_na_label`"
                            class="align-items-center mb-0"
                        >
                            <b-form-input :id="`editing-subs-radio-${sub_code}-enable_na_label`"
                                          v-model="enable_na_label"
                                          placeholder="해당없음 선택지 - 국문 문구"
                                          class="mb-1"
                                          size="sm"
                                          :disabled="!enable_na"
                            />
                        </b-form-group>
                    </template>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부문항"
                        :label-for="`editing-subs-radio-${sub_code}-has_attachment`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-radio-${sub_code}-has_attachment`"
                                         v-model="has_attachment"
                                         :disabled="required_opt_attachment"
                        >
                            파일 및 URL 첨부
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="선택지별 첨부"
                        :label-for="`editing-subs-radio-${sub_code}-required_opt_attachment`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-radio-${sub_code}-required_opt_attachment`"
                                         v-model="required_opt_attachment"
                                         :disabled="has_attachment"
                        >
                            선택지별 첨부 여부
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부필수"
                        :label-for="`editing-subs-radio-${sub_code}-required_attachment`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-radio-${sub_code}-required_attachment`"
                                         v-model="required_attachment"
                                         :disabled="!has_attachment && !required_opt_attachment"
                        >
                            첨부필수 문항
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="필수답변"
                        :label-for="`editing-subs-radio-${sub_code}-required_answer`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-radio-${sub_code}-required_answer`"
                                         v-model="required_answer"
                        >
                            필수답변
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Risk"
                        :label-for="`editing-subs-radio-${sub_code}-risk`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-radio-${sub_code}-risk`"
                                         v-model="sub_risk"
                        >
                            적용
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Tags"
                        :label-for="`editing-subs-radio-${sub_code}-tags`"
                        class="align-items-center mb-0"
                    >
                        <b-input :id="`editing-subs-radio-${sub_code}-tags`" v-model="tags"
                                 placeholder="띄어쓰기 대신 _ 사용, 쉼표로 구분"
                        />
                    </b-form-group>
                </b-list-group-item>
            </b-list-group>
        </template>

        <template #footer>
            <div class="text-right">
                <b-btn variant="blue" class="mr-2"
                       @click="handleSaveSub"
                       :disabled="is_saving_subs"
                >
                    <div class="d-flex align-items-center">
                        저장
                        <b-spinner v-show="is_saving_subs" small class="ml-2"/>
                    </div>
                </b-btn>
                <b-btn variant="dark" @click="$emit('click-cancel')">
                    취소
                </b-btn>
            </div>
        </template>
    </editing-sub-frame>
</template>

<script>
import {EditingSubComponentMixin} from '@core_mixins/EditingSubComponentMixin'
import EditingDFElement from '@core_components/admin/components/subs/editing/element/EditingDFElement'
import * as ih from '@core_utils/util'

export default {
    name: 'editing-df-radio',
    mixins: [
        EditingSubComponentMixin
    ],
    components: {
        'editing-df-element': EditingDFElement
    },
    data() {
        return {
            sub_data_contents_information: `text: 라디오 선택지 옆에 표시될 텍스트를 의미합니다. 
                value: 라디오 선택지를 선택했을 경우 저장될 값을 의미합니다. 'text'와 같을 수 있습니다. `,

        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
    },
    methods: {
        addRadio() {
            let new_radio_item = {
                text: '',
                value: ''
            }
            if (!this.sub_data_contents.structure) {
                this.$set(this.sub_data_contents, 'structure', [])
            }
            this.sub_data_contents.structure.push(new_radio_item)
        },
        async handleSaveSub() {
            await this.saveSub()
            this.$emit('click-save')
        },
        updateElementItem(item_index, element_idx, new_item) {
            this.$set(this.sub_data_contents.structure[item_index].element_contents, element_idx, new_item)
        },
        addElement(index) {
            let new_item = {type: '', result: '', structure: [], table_header: []}
            if (!this.sub_data_contents.structure[index]['element_contents']) {
                this.$set(this.sub_data_contents.structure[index], 'element_contents', [])
            }

            this.sub_data_contents.structure[index]['element_contents'].push(new_item)
        },
        deleteElement(index, element_idx) {
            let temp_element = JSON.parse(JSON.stringify(this.sub_data_contents.structure[index]))
            temp_element.element_contents.splice(element_idx, 1)
            this.$set(this.sub_data_contents.structure, index, ih.deepCopy(temp_element))
        },
        changeAttachmentCheckbox(item, field, value) {
            this.$set(item, field, value)
        },
    }
}
</script>
